import { render } from "./EpiBlockComponentSelector.vue?vue&type=template&id=c744ad50"
import script from "./EpiBlockComponentSelector.vue?vue&type=script&lang=js"
export * from "./EpiBlockComponentSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__